/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc1Inputs */

const en_fc_tut_sc1 = /** @type {(inputs: Fc_Tut_Sc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert edit`)
};

/**
* | output |
* | --- |
* | "Insert edit" |
*
* @param {Fc_Tut_Sc1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc1 = /** @type {((inputs?: Fc_Tut_Sc1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc1(inputs)
});
export { fc_tut_sc1 as "fc.tut.sc1" }